import React, { useState } from 'react';
import { TerminateHeader, ContentHeading } from '../molecules/ContentHeader';
import OperationCard from '../molecules/OperationCard';
import TerminateDate from '../molecules/TerminateDate';
import TerminateSubmitModal from '../molecules/TerminateSubmitModal';

import { useHistory } from 'react-router-dom';
import { hasContracts } from '../search-api/search-api-client';
import MessageModal from '../molecules/MessageModal';
import moment from 'moment';
import { ifBasePath, defaultProjectId } from '../../config/baseConfig';
import Redux from '../../redux/ReduxConnector';
import LocalStorage, { LocalStorageKey } from '../../utils/LocalStorage';
import { CircularProgress } from '@material-ui/core';
import { useSearchIndex } from '../../hooks/useSearchIndex';

const TerminateTemplate: React.FC = () => {
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
  const [terminateDate, setTerminateDate] = useState<string | undefined>(
    moment()
      .add(1, 'months')
      .format('YYYY-MM-DD')
  );
  const [allSpaceId, setAllSpaceId] = useState<string>('');
  const [contractId, setContractId] = useState<string>('');
  const [progress, setProgress] = React.useState(false);

  const history = useHistory();

  const index = useSearchIndex();

  const [spaceContractData, setSpaceContractData] = React.useState<any>(undefined);
  const [open, setOpen] = React.useState<boolean>(false);
  const [isError, setIsError] = React.useState<boolean>(false);

  const setIsModalOpen = React.useCallback(
    (e: any) => {
      setIsError(false);
      setIsOpenConfirmModal(e);
    },
    [setIsError, setIsOpenConfirmModal]
  );

  const getContractStartDate = React.useCallback((res: any) => {
    return res && res.contract && res.contract.occupyScheduledDate
      ? moment(res.contract.occupyScheduledDate).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');
  }, []);

  React.useEffect(() => {
    setProgress(true);
    const params = new URLSearchParams(history.location.search);
    const paramAllSpaceId = params.get('s') || '';
    const paramContractId = params.get('c') || '';
    setAllSpaceId(paramAllSpaceId);
    setContractId(paramContractId);

    fetch(`${ifBasePath}project/${defaultProjectId}/application/origin/${paramAllSpaceId}/${paramContractId}`, {
      method: 'POST',
      headers: {
        'x-api-key': Redux.getStore().user.accessToken || LocalStorage.get(LocalStorageKey.ACCESS_TOKEN) || '',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        refresh_token: Redux.getStore().user.refreshToken || LocalStorage.get(LocalStorageKey.REFRESH_TOKEN)
      })
    })
      .then(async response => {
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setProgress(false);
        index
          .search({
            filters: {
              'sumamoruData.sumamoruLinkable': ['true'],
              id: [paramAllSpaceId]
            },
            excludeFilters: {},
            length: 1000,
            offset: 0
          })
          .then(res => {
            const result = res.hits
              .filter(hasContracts)
              .map(hit =>
                hit.sumamoruData.contracts.map(contract => ({
                  base: hit,
                  sumamoruData: hit.sumamoruData,
                  contract: contract
                }))
              )
              .reduce((a, b) => a.concat(b), [] as any[])
              .filter(hit => hit.contract.contractId === paramContractId);
            setSpaceContractData({ ...data, ...result[0] });
            index.clearCache();
          })
          .catch(() => {
            setProgress(false);
          });
      })
      .catch(e => {
        console.log(e);
        setProgress(false);
      });
  }, [history.location.search, setSpaceContractData, setAllSpaceId, setContractId, index]);

  const detectError = React.useCallback(() => {
    setIsError(true);
  }, [setIsError]);
  const resetError = React.useCallback(() => {
    setIsError(false);
  }, [setIsError]);

  return (
    <>
      <TerminateHeader
        setIsModalOpen={setIsModalOpen}
        all_space_id={allSpaceId}
        contract_id={contractId}
        isError={isError}
        canCancel={!terminateDate}
        errorMessage={'連携に失敗しました。'}
      />
      <TerminateDate
        contractStartDate={getContractStartDate(spaceContractData)}
        terminateDate={terminateDate}
        setTerminateDate={setTerminateDate}
      />
      <ContentHeading text={'現在の契約内容'} />
      <OperationCard spaceContractData={spaceContractData} detectError={detectError} resetError={resetError} />
      <TerminateSubmitModal
        all_space_id={spaceContractData && spaceContractData.base.id}
        contract_id={spaceContractData && spaceContractData.contract.contractId}
        move_plan_date={spaceContractData && spaceContractData.contract.occupyScheduledDate}
        terminate_date={terminateDate}
        isOpen={isOpenConfirmModal}
        setIsOpen={setIsOpenConfirmModal}
        detectError={detectError}
        contractStartDate={getContractStartDate(spaceContractData)}
        terminateDate={terminateDate}
      />
      <MessageModal
        isOpen={open}
        setIsOpen={setOpen}
        title={'エラー'}
        message={['このデータはすでに解約処理が行われています。', 'もう一度処理を実行することはできません。']}
      />
      {progress && (
        <div>
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default TerminateTemplate;
